// ABOUTME: Global window.fetch wrapper adding the screen's dealership header to same-origin API calls.
// ABOUTME: Installed once at bootstrap; a pass-through while no screen works in a dealership.

import { DEALERSHIP_PATH_PREFIXES, REQUEST_DEALERSHIP_HEADER } from './constants';
import { getRequestDealership } from './requestDealershipStore';

const getRequestUrl = (input: RequestInfo | URL): string => {
    if (typeof input === 'string') return input;
    if (input instanceof URL) return input.href;
    return input.url;
};

/**
 * True for a same-origin URL under one of the dealership path prefixes. External URLs, and
 * anything that cannot be parsed, never get the header.
 */
export const isDealershipPath = (input: RequestInfo | URL, origin: string): boolean => {
    try {
        const url = new URL(getRequestUrl(input), origin);
        if (url.origin !== origin) return false;
        return DEALERSHIP_PATH_PREFIXES.some(
            prefix => url.pathname === prefix || url.pathname.startsWith(`${prefix}/`),
        );
    } catch {
        return false;
    }
};

/**
 * Wraps `window.fetch` so same-origin API calls carry `x-dealership` while a screen works in a
 * dealership. A header set by the caller wins.
 */
export const installRequestDealershipFetch = () => {
    const original = window.fetch.bind(window);
    window.fetch = (input: RequestInfo | URL, init?: RequestInit) => {
        const dealership = getRequestDealership();
        if (!dealership || !isDealershipPath(input, window.location.origin)) {
            return original(input, init);
        }
        const headers = new Headers(
            init?.headers ?? (input instanceof Request ? input.headers : undefined),
        );
        if (!headers.has(REQUEST_DEALERSHIP_HEADER)) {
            headers.set(REQUEST_DEALERSHIP_HEADER, dealership);
        }
        return original(input, { ...init, headers });
    };
};
